module.exports = __webpack_public_path__ + "static/media/about-berlin-poster-1.18069e36.png";